import { render, staticRenderFns } from "./SystemInformation.vue?vue&type=template&id=613ac635"
import script from "./SystemInformation.vue?vue&type=script&lang=js"
export * from "./SystemInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports